import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Default from "../views/layouts/Default.vue";
import GeneralRoutes from "./children/general";
import AuthRoutes from "./children/auth";
import { store } from "@/store";
import { Roles } from "@/helpers/enums/Roles";
import { AuthActionTypes } from "@/store/modules/auth/action-types";
import api from "@/api/index";
import { state } from "@/store/modules/auth/state";
import { getters } from "@/store/modules/auth/getters";
import axiosAgsc from "@/store/axiosAgsc";

const setPartner = async () => {
  const selectedPartner = localStorage.getItem("partner");
  if (selectedPartner) {
    try {
      store.dispatch(AuthActionTypes.SET_PARTNER, JSON.parse(selectedPartner));
    } catch (error) {
      console.log(error);
    }
  } else {
    try {
      const role: any = (
        store.state.auth.user.find(f => f.type == "role") || {}
      ).value;
      if (
        (role && role === Roles.CompanyAdmin) ||
        role === Roles.SiteAdmin ||
        role === Roles.GroupAdmin
      ) {
        return;
      }
      const partnerId: any = (
        store.state.auth.user.find(f => f.type == "PartnerId") || {}
      ).value;
      if (partnerId) {
        const res = await api.partners.getById(partnerId);
        if (res) {
          const partner = res.data.entityData;
          partner.guid = partner.id;
          store.dispatch(AuthActionTypes.SET_PARTNER, partner);
          localStorage.setItem("partner", JSON.stringify(partner));
        }
      }
    } catch (e) {
      console.log("index error", e);
    }
  }
};
const routes: any = [
  ...AuthRoutes,
  {
    path: "/password-reset",
    component: () => import("@/views/pages/PasswordReset.vue"),
  },
  {
    path: "/",
    name: "Default",
    meta: { requiresAuth: true },
    component: Default,
    children: [...GeneralRoutes],
    beforeEnter: async (to: any, from: any, next: any) => {
      try {
        await setPartner();
        const selectedCompany = localStorage.getItem("company");
        if (selectedCompany) {
          store.dispatch(AuthActionTypes.SET_COMPANY, {
            ...JSON.parse(selectedCompany),
            selected: true,
            agms: false,
          });
        } else {
          await axiosAgsc.get("User/GetUserClaimsInformation", {}).then(async response => {
            if (!response.data.entityData) {
              next();
              return;
            }
    
            const role: any = (
              store.state.auth.user.find(f => f.type == "role") || {}
            ).value;
    
            if (role && role === Roles.PartnerAdmin) {
              const partnerId = response.data.entityData.partnerId;
              const res = await api.partners.getById(partnerId);
              if (res) {
                const partner = res.data.entityData;
                partner.guid = partner.id;
                store.dispatch(AuthActionTypes.SET_PARTNER, {
                  ...partner,
                  selected: true,
                  agms: false,
                });
                localStorage.setItem("partner", JSON.stringify(partner));
              }
            } else {
              const companies = response.data.entityData.companies.map(
                (item: any) => ({
                  companyGuid: item.key,
                })
              );
              const guid = companies[0].companyGuid;
              const res = await api.companies.getByGuid(guid);
              if (res) {
                const company = res.data.entityData;
                store.dispatch(AuthActionTypes.SET_COMPANY, {
                  ...company,
                  selected: true,
                  agms: false,
                });
              }
            }
          });
        }
        next();
      } catch (e) {
         // try {
        //   const companyGuid: any = (
        //     store.state.auth.user.find(f => f.type == "CompanyGuid") || {}
        //   ).value;
        //   const guid = JSON.parse(companyGuid)[0];
        //   const res = await api.companies.getByGuid(guid);
        //   const company = res.data.entityData;
        //   store.dispatch(AuthActionTypes.SET_COMPANY, {
        //     ...company,
        //     selected: true,
        //     agms: false,
        //   });
        // } catch (e) {
        //   console.log("index error", e);
        // }
        next(); 
      }
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/pages/404.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes,
});

export default router;
